import { Autocomplete } from '@mui/material';

import { GDMAutocompleteComponent } from './GDMAutocomplete.type';

/* TODO: Implement component using GDM default design */
const GDMAutocomplete: GDMAutocompleteComponent = props => <Autocomplete {...props} />;

export default GDMAutocomplete;
